<template>
  <div>
    <common-table :table-columns="tableColumns"
                  :url="url"
                  :operate="operate"
                  :searchs="searchs"
                  :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";


export default {
  name: "Gallery",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'gallery:add',
        update: 'gallery:update',
        delete: 'gallery:delete',
        deleteBatch: 'gallery:deleteBatch'
      },
      url: {
        get: '/gallery/listByCondition',
        add: '/gallery/add',
        update: '/gallery/update',
        delete: '/gallery/delete/',
        delete_batch: '/gallery/deleteBatch',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '',
      },{
        field: 'img',
        label: '图片',
        detail: true,
        show: true,
        img: true,
        width: '',
      }, {
        field: 'img',
        label: '图片地址',
        show: true,
        width: '',
      }, {
        field: 'imageName',
        label: '图片名称',
        show: true,
        width: '',
      }, {
        field: 'type',
        label: '类型',
        show: {
          type: 'tag',
          tags: [{
            key: 1,
            value: '智能图库',
            type: 'success'
          },{
            key: 2,
            value: '其他',
            type: 'info'
          }]
        }
      }, ],
      operate: [{
        icon: 'el-icon-upload2',
        type: 'text',
        text: '上传图片',
        uploadImg: true,
        url: this.reUrl + '/system/upload/oss/img',
        // 用于存储handle的row
        value: {},
        handle: (row) => {
          this.value = row;
        },
        success: (res) => {
          if (res.code === 0) {
            const value = JSON.parse(JSON.stringify(this.value));
            value.img = res.data;
            this.$axios.post({
              url: '/gallery/img/update',
              data: value,
              success: (data) => {
                if (data.code === 0){
                  this.$message.success("图片上传成功");
                  this.$set(this.value, 'img', value.img);
                }else {
                  this.$message.error(data.msg ? data.msg: "图片上传失败");
                }
              }
            });
          } else if (res.code === 102) {
            window.localStorage.removeItem('username');
            window.localStorage.removeItem('sessionId');
            window.parent.location.href = this.feUrl + '/login.html';
          }
        }
      } ],
      formFields: {
        addTitle: '添加图片地址',
        updateTitle: '修改图片地址',
        model: [{
          field: 'agentId',
          label: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
          placeholder: '请选择',
          rules: [{
            message: '请选择代理', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        },{
          field: 'imageName',
          label: '图片名称',
          type: 'input',
          placeholder: '图片名称',
          rules: [{message: '请输入图片名称', trigger: 'blur', required: true}],
          add: true,
          update: true,
        },{
          field: 'type',
          label: '类型',
          type: 'select',
          selectData: [{
            id: 1,
            name: '智能投资',
          }, {
            id: 2,
            name: '其他',
          }],
          placeholder: '类型',
          rules: [{message: '请选择类型', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
